import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Ad from '@ifeng/ui_pc_ad';
import { getQuickSelectCar } from '../../../../../../services/api';

class QuickSelect extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            // 请求返回结果
            showData: [],
            // 请求接口参数
            paramObj: { guideprice: '', country: '', level: '', energy: '', biansu: '' },
            // 价格选择状态
            selectPrice: '',
            // 车型选择状态
            selectLevel: '',
            // 国家选择状态
            selectCountry: '',
            // 能源选择状态
            selectEnergy: '',
            // 变速箱选择状态
            selectBiansu: '',
        };
    }

    static propTypes = {};

    async componentDidMount() {
        // debugger;
        const initObj = { guideprice: '', country: '', level: '', energy: '', biansu: '' };
        const showData = await getQuickSelectCar(initObj);

        this.setState({
            showData,
        });
    }
    async handlePrice(id, item, param, target) {
        let priceObj = {};
        let selectPrice = '';

        if (this.state.selectPrice === id) {
            target.className = styles.off;
            selectPrice = '';
            priceObj = { guideprice: '' };
        } else {
            priceObj = { guideprice: encodeURIComponent(item) };
            selectPrice = id;
        }

        const paramObj = Object.assign(param, priceObj);

        const showData = await getQuickSelectCar(paramObj);

        this.setState({
            selectPrice,
            paramObj,
            showData,
        });
    }

    async handleLevel(id, item, param, target) {
        let levelObj = {};
        let selectLevel = '';

        if (this.state.selectLevel === id) {
            target.className = styles.off;
            selectLevel = '';
            levelObj = { level: '' };
        } else {
            levelObj = { level: encodeURIComponent(item) };
            selectLevel = id;
        }

        const paramObj = Object.assign(param, levelObj);

        const showData = await getQuickSelectCar(paramObj);

        this.setState({
            selectLevel,
            paramObj,
            showData,
        });
    }

    async handleCountry(id, item, param, target) {
        let countryObj = {};
        let selectCountry = '';

        if (this.state.selectCountry === id) {
            target.className = styles.off;
            selectCountry = '';
            countryObj = { country: '' };
        } else {
            countryObj = { country: encodeURIComponent(item) };
            selectCountry = id;
        }
        const paramObj = Object.assign(param, countryObj);

        const showData = await getQuickSelectCar(paramObj);

        this.setState({
            selectCountry,
            paramObj,
            showData,
        });
    }

    async handleEnergy(id, item, param, target) {
        let energyObj = {};
        let selectEnergy = '';

        if (this.state.selectEnergy === id) {
            target.className = styles.off;
            selectEnergy = '';
            energyObj = { energy: '' };
        } else {
            energyObj = { energy: encodeURIComponent(item) };
            selectEnergy = id;
        }

        const paramObj = Object.assign(param, energyObj);

        const showData = await getQuickSelectCar(paramObj);

        this.setState({
            selectEnergy,
            paramObj,
            showData,
        });
    }

    async handleBiansu(id, item, param, target) {
        let biansuObj = {};
        let selectBiansu = '';

        if (this.state.selectBiansu === id) {
            target.className = styles.off;
            selectBiansu = '';
            biansuObj = { biansu: '' };
        } else {
            biansuObj = { biansu: encodeURIComponent(item) };
            selectBiansu = id;
        }

        const paramObj = Object.assign(param, biansuObj);

        const showData = await getQuickSelectCar(paramObj);

        this.setState({
            selectBiansu,
            paramObj,
            showData,
        });
    }

    ViewSelect(_data) {
        // 价格渲染
        const displayPrice = price => {
            let priceArr = ['10-15万', '15-20万', '20-25万', '25-35万', '35-50万', '35-50万', '50-100万', '100万以上'];
            let m = [];

            for (let i = 0; i < priceArr.length; i++) {
                let x = i + 1;

                m.push(
                    <a
                        key={i}
                        className={x === price ? styles.on : styles.off}
                        onClick={e => this.handlePrice(x, priceArr[i], this.state.paramObj, e.target)}
                        data-index={priceArr[i]}
                        data-name="guideprice">
                        {priceArr[i]}
                    </a>,
                );
            }

            return m;
        };
        // 车型渲染
        const displayLevel = level => {
            let levelArr = ['SUV', 'MPV', '小型车', '紧凑型车', '中型车', '大中型车', '豪华车', '跑车'];
            let m = [];

            for (let i = 0; i < levelArr.length; i++) {
                let x = i + 1;

                m.push(
                    <a
                        key={i}
                        className={x === level ? styles.on : styles.off}
                        onClick={e => this.handleLevel(x, levelArr[i], this.state.paramObj, e.target)}
                        data-index={levelArr[i]}
                        data-name="level">
                        {levelArr[i]}
                    </a>,
                );
            }

            return m;
        };

        // 国家渲染
        const displayCountry = country => {
            let countryArr = ['中国', '日本', '德国', '美国', '韩国', '法国', '英国', '意大利'];
            let m = [];

            for (let i = 0; i < countryArr.length; i++) {
                let x = i + 1;

                m.push(
                    <a
                        key={i}
                        className={x === country ? styles.on : styles.off}
                        onClick={e => this.handleCountry(x, countryArr[i], this.state.paramObj, e.target)}
                        data-index={countryArr[i]}
                        data-name="country">
                        {countryArr[i]}
                    </a>,
                );
            }

            return m;
        };
        // 能源渲染
        const displayEnergy = energy => {
            let energyArr = ['汽油', '纯电动', '混合动力'];
            let m = [];

            for (let i = 0; i < energyArr.length; i++) {
                let x = i + 1;

                m.push(
                    <a
                        key={i}
                        className={x === energy ? styles.on : styles.off}
                        onClick={e => this.handleEnergy(x, energyArr[i], this.state.paramObj, e.target)}
                        data-index={energyArr[i]}
                        data-name="energy">
                        {energyArr[i]}
                    </a>,
                );
            }

            return m;
        };
        // 变速箱渲染
        const displayBiansu = biansu => {
            let biansuArr = ['手动', '自动', '手自一体'];
            let m = [];

            for (let i = 0; i < biansuArr.length; i++) {
                let x = i + 1;

                m.push(
                    <a
                        key={i}
                        className={x === biansu ? styles.on : styles.off}
                        onClick={e => this.handleBiansu(x, biansuArr[i], this.state.paramObj, e.target)}
                        data-index={biansuArr[i]}
                        data-name="biansu">
                        {biansuArr[i]}
                    </a>,
                );
            }

            return m;
        };

        const displayCar = list => {
            const carList = [];

            if (list && list.length > 0) {
                carList.push(
                    <ul key="car_lst_ul" className={styles.ptlist}>
                        {list.map((item, index) => (
                            <li key={index}>
                                <div>
                                    <a href={`//car.auto.ifeng.com/series/${item.serialid}`} target="_blank">
                                        <img className={styles.car_image} src={item.seriallogo} />
                                    </a>
                                </div>
                                <strong>
                                    <a href="//db.auto.sohu.com/model/i/1002/index" target="_blank">
                                        {item.serialname}
                                    </a>
                                </strong>
                                <p>
                                    <a href="//db.auto.sohu.com/model/i/1002/index" target="_blank">
                                        <span className={styles.red}>{item.guideprice}</span>
                                        万
                                    </a>
                                </p>
                            </li>
                        ))}
                    </ul>,
                );
            } else {
                carList.push(
                    <li className={styles.nullCar} key="nullCar">
                        搜索条件没有相关数据
                    </li>,
                );
            }

            return carList;
        };

        return (
            <div>
                <dl className={styles.selcar_tag}>
                    <dt className={styles.wid1}>价格</dt>
                    <dd id="priceId" className={styles.wid2}>
                        {displayPrice(this.state.selectPrice)}
                    </dd>

                    <dt className={styles.wid1}>车型</dt>
                    <dd className={styles.wid2}>{displayLevel(this.state.selectLevel)}</dd>
                    <dt className={styles.wid1}>国别</dt>
                    <dd className={styles.wid2}>{displayCountry(this.state.selectCountry)}</dd>
                    <dt className={styles.wid1}>能源</dt>
                    <dd className={styles.wid3}>{displayEnergy(this.state.selectEnergy)}</dd>
                    <dt className={styles.wid4}>变速箱</dt>
                    <dd className={styles.wid3}>{displayBiansu(this.state.selectBiansu)}</dd>
                </dl>

                {displayCar(_data.data)}
            </div>
        );
    }
    /**
     * 渲染组件
     */
    render() {
        return <div className={styles.tabcon_cur}>{this.ViewSelect(this.state.showData)}</div>;
    }
}

export default QuickSelect;
